import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { COLUMNS_HEADER_PACKAGERS_ADMIN } from '../../core/constants/tables.constants';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { PackagingMachinesService } from '../../core/services/packaging-machines.service';
import { ValueStream } from '../../core/enums/general.enum';

@Component({
  selector: 'app-packaging-machines',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, GenericTableComponent, SpinnerComponent, FontAwesomeModule],
  templateUrl: './packaging-machines.component.html',
  styleUrl: './packaging-machines.component.scss'
})
export class PackagingMachinesComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_PACKAGERS_ADMIN;
  valueStreamValues = Object.values(ValueStream);

  packagers: any;
  packagersFiltered: any;

  filters: any = {
    value_stream: {
      value: '',
      filter: (obj: any): boolean => obj.value_stream === this.filters.value_stream.value
    },
  };

  isModalActive = false;
  isLoading = false;
  isCreating = false;
  isDeleting = false;

  faSpinner = faSpinner;

  form: FormGroup = this.formBuilder.group({
    id: ['', Validators.required],
    description: ['', Validators.required],
    value_stream: ['', Validators.required],
    active: [false, Validators.required],
    parallel: [false, Validators.required]
  });

  constructor(
    private packagersSvc: PackagingMachinesService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getPackagingMachines();
  }

  onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getPackagingMachines();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`La envasadora ${this.form.value.id} ha sido creada correctamente`);
        } else {
          this.toastr.success(`La envasadora ${this.form.value.id} ha sido actualizada correctamente`);
        }
        this.form.reset();
      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        this.packagersSvc.createPackagingMachine(this.form.value).subscribe(responseAction);
      } else {
        this.packagersSvc.updatePackagingMachine(this.form.value).subscribe(responseAction);
      }
    }

  }

  getPackagingMachines() {
    this.packagersSvc.getPackagingMachines().subscribe((res: any) => {
      this.packagers = res;
      this.packagersFiltered = res;
    });
  }

  onFilter() {
    this.packagersFiltered = this.packagers.filter((obj: any) => {
      return Object.keys(this.filters).map(f =>
        !this.filters[f].value ? true : this.filters[f].filter(obj)
      ).every(f => f);
    });
  }

  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.packagersSvc.deletePackagingMachine(item.id).subscribe({
      next: () => {
        this.getPackagingMachines();
        this.isLoading = false;
        this.toastr.success(`La envasadora ${item.id} ha sido eliminada correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }
}
